import API from "../api";

export const voidConfirmationNumber = confirmationID => {
  return API.agent().delete(`/billing/void/${confirmationID}`);
};
